export default function setupGameConfig(variantId) {
  const config = {
    // add your game config options here, these can be the default values
    levels: null, // set to an array of keys (found in gameData.levels) to restrict the levels, if levels are restricted, the level selection screen is not used
    wordExcludeList: null, // set to an array of words that should be omitted from levels
  };
  switch (variantId) {
    // switch on your variant IDs here and set the needed config values
    case 'buggy-cup-breakfast-a': // kindergarten
      config.levels = ['buggy_cuppy', 'breakfast'];
      config.wordExcludeList = ['SIGN'];
      break;
    case 'lost-lunch-queenly-home-a': // 1st grade
      config.levels = ['lost_lunch', 'queenly_home'];
      config.wordExcludeList = ['SOFA', 'WOMAN'];
      break;
    case 'birthday-bash-lake-friends-night-attic-a': // 2nd grade
      config.levels = ['birthday_bash', 'lake_friends', 'night_attic'];
      break;
    case 'party-ride-check-up-cow-tour-a': // 3rd grade
      config.levels = ['party_ride', 'check_up', 'cow_tour'];
      break;
  }
  return config;
}